let VCA = VCA || {};

VCA.ExpertGuidancePetPage = (function ($) {

    let ui = {};

    function cacheUI() {
        ui.$TabBtn = $('.js-expert-guidance-btn');
        ui.$TabContent = $('.petpage-expert-guidance__content');
        ui.$DisplayTitle = $('.petpage-expert-guidance__title');
    }

    function bindEvents() {
        ui.$TabBtn.on('click', displayContent);
    }

    function displayContent(e) {
        e.preventDefault();

        const btn = $(e.currentTarget);
        const tabNumber = btn.data('nav');
        const tabName = btn.data('name');
        const contentContainer = $('.petpage-expert-guidance__content-container');
        const contentToActivate = $(contentContainer).find(`.petpage-expert-guidance__content[data-nav-content="${tabNumber}"]`)[0];
        let tabBtnIsActive = btn.hasClass('active');

        if (tabBtnIsActive) {
            return;
        }

        ui.$TabBtn.each((idx,btn) => {
            $(btn).removeClass('active');
        });

        ui.$TabContent.each((idx,content) => {
            $(content).removeClass('active');
        });

        btn.addClass('active');
        $(contentToActivate).addClass('active');
        ui.$DisplayTitle.text(tabName);
    }


    function init() {
        if ($('.petpage-expert-guidance').length <= 0) {
            return;
        }

        cacheUI();
        bindEvents();
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    $(document).ready(function() {
        VCA.ExpertGuidancePetPage.init();
    });
});
